import Vehicle from "./veiculo.model";

export enum UserType {
  Caller = 0,
  Driver = 1,
  Passenger = 2,
  Restaurant = 4
}

export interface Motorista {
  id: string;
  nome: string;
  celular: string;
  documento: string;
  idiomas: number[];
  veiculo: Vehicle;
  email: string;
  senha: string;
}

export interface Vendedor {
  id: string;
  nome: string;
  celular: string;
  nomeEstabelecimento: string;
  enderecoEstabelecimento: string;
  telefoneEstabelecimento: string;
  email: string;
  senha: string;
}

export interface UserLogin {
  email: string;
  password: string;
  rememberMe: boolean;
}

export interface ResponseAPI {

  errors?: string[],
  success: boolean,
  data?: any

}

export interface User {
  cellPhone: string;
  document: string;
  email: string;
  id: string;
  name: string;
  status: number;
  lineId: string;
  token: string;
  restaurante: string;
  userType: UserType;
  dataFimUtilizacao: Date;
  veiculo: Vehicle;
}

export interface EnterInLineViewModel {
  raceId?: any;
  telefone: any;
  nomePassageiro: any;
  sellerId: string;
  // lineId: string;
  driverId: string;
  acceptedRace: boolean;
  latitude: string;
  longitude: string;
}
export interface AcceptRaceViewModel {
  raceId: string;
  // lineId: string;
  driverId: string;
}
export interface RaceRequestViewModel {
  clearRefusals: boolean;
  driverId: string;
  sellerId: string;
  destinationId: string;
  passengerName: string;
  observation: string;
  telephoneNumber: string;
  language: number;
  languages: number[];
  vehicleType: number;
  raceType: number;
  scheduledRaceDate: Date;
  latitudeOrigem: string;
  latitudeDestino: string;
  longitudeOrigem: string;
  longitudeDestino: string;
  enderecoOrigem: string;
  enderecoDestino: string;
  coupon: string;
  raceId?: string;
  waitingHours?: number;
  formaPagamento?: number; // 0 = Cash, 1 = Stripe Link
}
